// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PManOutlinedSvg from "@fishx/icons-svg/es/asn/PManOutlined";
import FishxIcon from '../components/FishxIcon';

var PManOutlined = function PManOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PManOutlinedSvg
  }));
};

PManOutlined.displayName = 'PManOutlined';
export default React.forwardRef(PManOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PManOutlined.js
// module id = 3499
// module chunks = 0